import { DeliveriesListActions } from './actions/deliveries-list.actions';
import { ReceiveDeliveryModal } from './actions/receive-delivery/receive-delivery.component';
import { useDeliveriesList } from './hooks/use-deliveries-list.hook';

export function DeliveriesListActionsObserver({
  projectID,
  handlers,
  state
}: {
  projectID: string;
  state: ReturnType<typeof useDeliveriesList>['state'];
  handlers: ReturnType<typeof useDeliveriesList>['handlers'];
}) {
  switch (state.currentAction) {
    case DeliveriesListActions.CREATE_DELIVERY:
      return (
        <ReceiveDeliveryModal
          projectID={projectID}
          onSuccess={() => handlers.endAction()}
          onAbort={() => handlers.endAction()}
        />
      );
    default:
      return null;
  }
}
